import { Component, Input, OnInit } from '@angular/core';
import { AlertController, IonicModule } from '@ionic/angular';
import { AnimationService } from '../../services/animation.service';
import { TranslatePipe } from '../../translate/pipes/translate.pipe';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '../../translate/translate.module';
import { NavigationService } from '../../services/navigation.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-error-dialog',
  templateUrl: './error-dialog.component.html',
  styleUrls: ['./error-dialog.component.scss'],
  standalone: true,
  imports: [IonicModule, CommonModule, TranslateModule]
})
export class ErrorDialogComponent {

  @Input() header: string;
  @Input() message: string;

  constructor(
    private alertController: AlertController,
    private animationService: AnimationService,
    private tp: TranslatePipe,
    private navigationService: NavigationService,
    private router: Router
  ) {
  }

  async presentAlert(navigate = true) {
    const buttons: any[] = [];
    const closeButton: any = {
      text: this.tp.transform("CLOSE"),
      role: 'cancel'
    }

    if (navigate) {
      closeButton.handler = () => {
        const isLoginOrPolicy = this.router.url.includes('login') || this.router.url.includes('privacy-policy');
        let target;
        if (isLoginOrPolicy) {
          target = isLoginOrPolicy ? 'login' : 'home';
          this.navigationService.navigateRootInstant(target);
        } else if (this.router.url.includes('quiz-feedback')) {
          return;
        }
      }
    }

    buttons.push(closeButton);

    const alert = await this.alertController.create({
      header: this.header,
      message: this.message,
      cssClass: 'error-alert',
      buttons: buttons,
      enterAnimation: (baseEl: HTMLElement) => {
        return this.animationService.dissolveDialogAnimation(baseEl, 0.75);
      },
      leaveAnimation: (baseEl: HTMLElement) => {
        return this.animationService.dissolveDialogReversedAnimation(baseEl, 0.75);
      },
      backdropDismiss: false
    });

    alert.addEventListener('ionAlertWillDismiss', async (event) => {
      if (event.detail.role === 'backdrop') {
        const alertElement = document.querySelector('.error-alert');
        if (alertElement) {
          const animation = this.animationService.dissolveDialogReversedAnimation(alertElement as HTMLElement, 0.75);
          await animation.play();
        }
      }
    });

    const alertEl = document.querySelector('ion-alert');
    if (alertEl) {
      alertEl.setAttribute('data-test', 'error-dialog-errorpanel-alert');

      if (this.router.url.includes('login') || this.router.url.includes('registration')) {
        alertEl.classList.add('cert-alert');
      }

    }
    await alert.present();
    return alert;
  }
}
